import { CSSProperties } from 'react'

import classNames from 'classnames'

import './Sublist.scss'

interface EntityListProps {
  className?: string
  style?: CSSProperties
  children?: React.ReactNode
}

export const Sublist: React.FC<EntityListProps> = ({
  className,
  style,
  children,
}) => {
  return (
    <div className={classNames('sublist', className)} style={{ ...style }}>
      {children}
    </div>
  )
}
